import { IGridElement, ISheetHeaders } from "../../types";

export const mapLinkToApi = (headers: ISheetHeaders, rowData: IGridElement[]) =>
  headers.map((h, index) => {
    const cellValue = rowData[index].value;
    const isSelect = h.type === "select";
    if (!isSelect) {
      return {
        id: h.id,
        name: h.label,
        valueText: cellValue,
      };
    }
    // try to get valueText from options
    const options = rowData[index].options;
    let selectedOptionsId = cellValue ? Number(cellValue) : null;
    let selectedOptionsText = cellValue;
    if (cellValue) {
      const cellValueNumber = Number(cellValue);
      // parsing number worked?
      if (!Number.isNaN(cellValueNumber)) {
        if (options) {
          const selectedOption = options.find(
            (e) => e.value.id === cellValueNumber
          );
          if (selectedOption) {
            selectedOptionsText = selectedOption.label;
          }
        }
      } else {
        // value not a number -> try to find the right id
        selectedOptionsText = cellValue;
        if (options) {
          const selectedOption = options.find(
            (e) => e.value.name === cellValue
          );
          if (selectedOption) {
            selectedOptionsId = selectedOption.value.id;
          }
        }
      }
    }
    return {
      id: h.id,
      name: h.label,
      selectedItemId: selectedOptionsId ? Number(selectedOptionsId) : null,
      valueText: selectedOptionsText,
    };
  });



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/mapLinkToApi.ts